import { FunctionComponent } from "react";

interface IProps {
	icon: JSX.Element;
	input: JSX.Element;
}

const FormField: FunctionComponent<IProps> = (props) => {
	const { icon, input } = props;
	return <div className="form">
		{icon}
		{input}
	</div>;
};

export default FormField;